import React, { useState } from 'react'
import Picker from '@wojtekmaj/react-daterange-picker/dist/entry.nostyle'
import { CalendarProps } from 'react-calendar'
// import Picker from 'react-daterange-picker'
// import 'react-daterange-picker/dist/css/react-calendar.css'
import styles from './DateRangePicker.module.scss'
import cl from 'classnames'
// import * as Moment from 'moment';
// import { extendMoment } from 'moment-range';

import './Calendar.css'
import './DateRangePicker.css'
import './react-calendar.css'
import { DateRangePickerProps, PeriodValue } from './DateRangePicker.types'
import moment from 'moment'
import { parsePeriodToDates } from './DateRangePicker.utils'

// const moment = extendMoment(Moment);

const DateRangePicker = (props: DateRangePickerProps) => {
  const {
    visible,
    setVisibility,
    initialValue,
    onSelect,
    className = ''
  } = props
  // const today = moment();
  // const [isOpen, setIsOpen] = useState(false);
  // const parseInitDateRange = () => {
  //   if (!initialValue) return '';

  //   const startDate = initialValue.split('-')[0].trim();
  //   const endDate = initialValue.split('-')[1].trim();
  //   console.log('startDate', startDate);
  //   console.log('endDate', endDate);
  //   return moment.range(moment(startDate), moment(endDate));
  // };
  const [value, setValue] = useState<PeriodValue>(initialValue)

  // const handleOnSelect = (v: PeriodValue) => {
  //   console.log('v', v)
  //   setValue(v)
  //   onSelect(v)
  // }

  const handleOnChange = (dates: Date[]) => {
    const period: PeriodValue = dates
      ? {
        start: moment(dates[0]),
        end: moment(dates[1])
      }
      : null
    setValue(period)
    onSelect(period)
  }

  // const containerStyles = [styles.container]
  // visible && containerStyles.push(styles.visible)
  // containerStyles.push(className)

  const calendarProps: CalendarProps = {
    value: parsePeriodToDates(value),
    onChange: handleOnChange as any,
    showDoubleView: true
  }

  if (!visible) return null

  return (
    <div
      className={cl(styles.container, { [styles.visible]: visible }, className)}
    >
      <div
        className={styles.wrapper}
        onMouseLeave={() => setTimeout(() => setVisibility(false), 300)}
      >
        {<Picker autoFocus={true} {...calendarProps} />}
      </div>
    </div>
  )
}

export default DateRangePicker
